import { render, staticRenderFns } from "./FMobileBind.vue?vue&type=template&id=64f35597&"
import script from "./FMobileBind.vue?vue&type=script&lang=js&"
export * from "./FMobileBind.vue?vue&type=script&lang=js&"
import style0 from "./FMobileBind.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FMobileBind.vue"
export default component.exports